import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, NgModel, FormControlName } from '@angular/forms';
import { AxisTextareaAutosizeDirective } from './axis-textarea-autosize.directive';
import { CountDownComponent } from './countdown.component';
import { CounterComponent } from './counter.component';
import { CounterSharedService } from './counterSevice';
import { CounterValueComponent } from './counterValue.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  providers: [CounterSharedService, NgModel, FormControlName],
  entryComponents: [CounterValueComponent],
  declarations: [
    CountDownComponent,
    CounterComponent,
    CounterValueComponent,
    AxisTextareaAutosizeDirective
  ],
  exports: [
    CountDownComponent,
    CounterComponent,
    CounterValueComponent,
    AxisTextareaAutosizeDirective
  ]
})
export class CountModule {}
